export default "__VITE_ASSET__CMgvXVQL__"